<template>
  <!-- 用户密码登录 -->
  <div class="ogin_box">
    <div class="login_tabs flex">
      <p class="login_tabsP">用户绑定</p>
    </div>
    <!-- 免密码登录 -->
    <div class="login_inputIphone">
      <div class="inputIphone flex" style="position: relative">
        <p>中国+86</p>
        <input
          type="text"
          placeholder="请输入手机号"
          v-model="mobile"
          @blur="mobileReg"
        />
      </div>
      <!-- <p class="loginTabsMessage" v-if="!isExistsLoginTabs">手机号未注册</p> -->
      <div class="registered_validation2 flex" v-if="vcodes">
        <i class="el-icon-check"></i>
        <p>验证成功</p>
      </div>
      <div class="registered_validation flex" @click="getValidation" v-else>
        <img src="../../assets/validation.png" alt="" />

        <p>点击按钮开始安全验证</p>
        <Vcode
          :show="validation"
          @success="onValidation('yes')"
          @fall="onValidation('no')"
          @close="onClose"
          :imgs="imgUrls"
        />
      </div>

      <div class="inputIphone_mess">
        <input type="text" placeholder="请输入短信验证码" v-model="smsCode" />
        <span class="blue" @click="getCountdown" v-if="canClick"
          >获取短信验证码</span
        >
        <span v-else style="color: #b5b5b5">{{ timeClock }}s</span>
      </div>
    </div>
    <div class="login_button">
      <button @click="getLogin">登 录</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Vcode from "vue-puzzle-vcode";
import { weChatBind,
        getUserAndPassLogin,
        getSecurityCode,
        getSmscode,
        existsUserName
} from "../../utils/interface";

export default {
  components: { Vcode },
  props: {
      userMess: {
          type: Object,
      }
  },
  data() {
    return {
      validCode: "",
      username: "",
      mobile: "",
      smsCode: "",
      vcodes: false,
      validation: false,
      imgUrls: "https://picsum.photos/200/300",
      canClick: true,
      timeClock: 60,
      // isExistsLoginTabs: true,
      fromPath: "",
      clock: null,
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path;
    });
  },
  methods: {
    ...mapMutations(["vuexAllPark", "isLoginVuex"]),
    // 手机失去焦点时的校验
    mobileReg(){
      const reg = /^[1][3-9]\d{9}$/;
      if(!reg.test(this.mobile)){
        this.$alert("请输入正确的手机号码", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    getLogin() {
        console.log('jfjsafkjasjf', this.userMess);
      window.clearInterval(this.clock);
      this.clock = null;
      this.timeClock = 60;
      this.canClick = true;
      const reg = /^[1][3-9]\d{9}$/;
      let params = {
        mobile: this.mobile,
        smsCode: this.smsCode,
        headerUrl: this.userMess.headerUrl,
        nick: this.userMess.nick,
        openId: this.userMess.openId,
        unionId: this.userMess.unionId,
      };
      // 短信登录
        if (
          this.mobile == "" ||
          !reg.test(this.mobile) ||
          this.smsCode == "" ||
          this.vcodes == false
          // this.isExistsLoginTabs === false
        ) {
          if (this.mobile == "") {
            this.$alert("请填写用户名", "提示", {
              confirmButtonText: "确定",
            });
          } else if (!reg.test(this.mobile)) {
            this.$alert("请输入正确的手机号码", "提示", {
              confirmButtonText: "确定",
            });
          } else if (this.smsCode == "") {
            this.$alert("请输入验证码", "提示", {
              confirmButtonText: "确定",
            });
          } else if (this.vcodes == false) {
            this.$alert("请进行安全验证", "提示", {
              confirmButtonText: "确定",
            });
          }
          // else if (!this.isExistsLoginTabs) {
          //   this.$alert("手机号未注册，请先注册", "提示", {
          //     confirmButtonText: "确定",
          //   });
          // }
        } else {
          weChatBind(params)
            .then((res) => {
              if(res.success){
                if(res.data.success){
                  if (res.data.token.access_token) {
                    this.$cookies.remove("api_access_token");
                    this.$cookies.set("api_access_token", res.data.token.access_token);
                    this.$cookies.set("api_token_new", res.data.token.access_token);
                    this.isLoginVuex(true);
                    // 成功后直接跳转
                    this.$nextTick(() => {
                      if (
                          this.fromPath === "/forgetPassword" ||
                          this.fromPath === "/registered" ||
                          this.fromPath === "/login"
                      ) {
                        this.$router.push("/");
                      } else {
                        this.$router.go(-1);
                      }
                    });
                  } else {
                    this.$alert(res.error, "提示", {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        this.mobile = "";
                        this.smsCode = "";
                        this.vcodes = false;
                        this.canClick = true;
                      },
                    });
                  }
                }else{
                  this.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      this.mobile = "";
                      this.smsCode = "";
                      this.vcodes = false;
                      this.canClick = true;
                    },
                  });
                }
              }else{
                this.$alert(res.message, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.mobile = "";
                    this.smsCode = "";
                    this.vcodes = false;
                    this.canClick = true;
                  },
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
    },
    // 拼图验证码
    getValidation() {
      const reg = /^[1][3-9]\d{9}$/;
      if (!reg.test(this.mobile)) {
          this.$alert("请输入正确登录手机号", "提示", {
          confirmButtonText: "确定",
        });
        this.validation = false
        return
      }
      // if (!this.isExistsLoginTabs) {
      //   this.$alert("请输入正确登录手机号", "提示", {
      //     confirmButtonText: "确定",
      //   });
      //   return;
      // }
      this.validation = true;
    },
    // 用户的验证回调
    onValidation(status, msg) {
      if (status == "yes") {
        // this.vcodes = true;
        let params = { account: this.mobile };
        getSecurityCode(params)
          .then((res) => {
            this.vcodes = res.success;
            this.validCode = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (status == "no") {
        this.vcodes = false;
      }
      this.validation = false; // 通过验证后，需要手动隐藏模态框
      //可以在此加上axios或其他代码
    },
    // 用户点击遮罩层，应该关闭模态框
    onClose() {
      this.validation = false;
      this.$message({
        message: "取消验证！",
        type: "warning",
      });
    },
    // 倒计时60s
    getCountdown() {
      if (this.vcodes == true) {
        let params = {
          mobile: this.mobile,
          validCode: this.validCode,
        };
        getSmscode(params)
          .then((res) => {
            // console.log("res", res);
            if (res.success == true) {
              this.canClick = false;
              if (this.clock != null) return;
              this.clock = window.setInterval(() => {
                if (this.timeClock > 0) {
                  this.timeClock--;
                } else if (this.timeClock <= 0) {
                  window.clearInterval(this.clock);
                  this.clock = null;
                  this.timeClock = 60;
                  this.canClick = true;
                }
              }, 1000);
            } else {
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        if (!this.vcodes) {
          this.$alert("安全验证失败，请重新验证", "提示", {
            confirmButtonText: "确定",
          });
        }
        // if (!this.isExistsLoginTabs) {
        //   this.$alert("手机号未注册，请先注册", "提示", {
        //     confirmButtonText: "确定",
        //   });
        // }
      }
    },
    // 校验用户是否存在
    // existsUserName() {
    //     if (this.mobile) {
    //       existsUserName({ username: this.mobile }).then((res) => {
    //         this.isExistsLoginTabs = res.success;
    //       });
    //     } else {
    //       this.isExistsLoginTabs = true;
    //     }
    // },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #009999;
}
.login_box {
  .login_tabs {
    font-size: 18px;

    p {
      margin-right: 36px;
      height: 34px;
      cursor: pointer;
    }

    .login_tabsP {
      border-bottom: 2px solid #009999;
      color: #009999;
    }
  }

  .login_inputIphone {
    width: 100%;
    margin-top: 50px;

    .inputIphone {
      color: rgb(189, 189, 189);
      margin-bottom: 20px;

      align-items: center;

      p {
        margin-right: 10px;
      }

      input {
        width: 86%;
        height: 60px;
        border: 1px solid #f9f9f9;
        border-radius: 10px;
        background: #fff;
        font-size: 16px;
        padding-left: 20px;
        color: #777;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
      }
    }

    .registered_validation2 {
      background: #3aead336;
      height: 52px;
      margin-bottom: 25px;
      align-items: center;
      color: #777;
      cursor: default;
      justify-content: center;
      color: #6dcaaa;
      border: 1px solid #6dcaaa;

      i {
        font-size: 20px;
        font-weight: bold;
        margin-right: 10px;
      }
    }

    .registered_validation {
      background: #f9f9f9;
      height: 52px;
      margin-bottom: 25px;
      align-items: center;
      color: #777;
      cursor: pointer;

      img {
        margin: 0 13px;
      }

      .validationVerify {
        z-index: 99;
      }
    }

    .inputIphone_mess {
      width: 100%;
      position: relative;

      input {
        border: 1px solid #f9f9f9;
        border-radius: 10px;
        background: #fff;
        width: 100%;
        height: 60px;
        padding-left: 20px;
        font-size: 16px;
        color: #777;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
      }

      span {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }

  .login_input {
    width: 100%;
    margin-top: 50px;

    input {
      border: 1px solid #f9f9f9;
      border-radius: 10px;
      background: #fff;
      width: 100%;
      height: 60px;
      padding-left: 20px;
      font-size: 16px;
      color: #777;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    input:nth-child(1) {
      margin-bottom: 20px;
    }

    input::-webkit-input-placeholder {
      color: #b3b3b3;
    }

    /deep/ .el-input__inner {
      border: 1px solid #f9f9f9;
      border-radius: 10px;
      background: #fff;
      width: 100%;
      height: 60px;
      padding-left: 20px;
      font-size: 16px;
      color: #777;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    /deep/ .el-input__inner::-webkit-input-placeholder {
      color: #b3b3b3;
    }
  }

  .login_button {
    width: 100%;
    margin: 24px 0 20px;

    button {
      border: none;
      background: #009999;
      width: 100%;
      height: 50px;
      color: #fff;
      font-weight: bold;
      font-size: 18px;
      border-radius: 10px;
    }
  }

  .login_small {
    color: #bdbdbd;
    width: 100%;
    align-items: center;
    justify-content: center;

    i {
      width: 1px;
      height: 15px;
      background: #bdbdbd;
      margin: 0 20px;
    }

    p {
      cursor: pointer;
    }
  }

  .login_mess {
    color: #777;
    margin-top: 14px;
    line-height: 25px;

    span {
      cursor: pointer;
    }
  }

  .login_mess2 {
    color: #777;
    margin-top: 60px;
    line-height: 25px;

    span {
      cursor: pointer;
    }
  }
}
.loginTabsMessage {
  font-size: 12px;
  position: relative;
  left: 0;
  bottom: 9px;
  width: 100%;
  height: 35px;
  background: #f8d7da;
  border: #f5c6cb;
  line-height: 35px;
  padding: 0 20px;
  box-sizing: border-box;
  color: #721c24;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/sweepCodeIdentity.vue